import { useTranslation } from 'react-i18next';

const ContactPage = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center min-h-screen bg-brand-background text-brand-brown p-4 pt-8 dark:bg-gray-900 dark:text-gray-300">
      <div className="w-full max-w-3xl space-y-6 text-center">
        <header className="space-y-2">
          <h1 className="text-3xl font-semibold text-brand-green dark:text-gray-100">
            {t('contact.title')}
          </h1>
          <p className="text-muted-foreground dark:text-gray-300">
            {t('contact.description')}
          </p>
        </header>
        <section>
          <a
            href="mailto:contacts@tulasihome.com"
            className="text-lg font-medium underline hover:text-foreground"
          >
            contacts@tulasihome.com
          </a>
        </section>
      </div>
    </div>
  );
};

export default ContactPage;
